import { del, get, post, put, urlApiTegra } from "../../../service/api";

export const getTaxes = async (token: string): Promise<any> => {
  return get(`${urlApiTegra}/tax`, token);
};

export const getTaxesSimpleById = ({ token, id }: { token: string; id: number | string }) => {
  return get(`${urlApiTegra}/cost-simple-national/${id}`, token);
};

export const getTaxesPresumedById = ({ token, id }: { token: string; id: number | string }) => {
  return get(`${urlApiTegra}/presumed-profit/${id}`, token);
};

export const postTaxesSimple = async ({ token, body }: { token: string; body: any }) => {
  return post(`${urlApiTegra}/cost-simple-national`, body, token);
};

export const postTaxesPresumed = async ({ token, body }: { token: string; body: any }) => {
  return post(`${urlApiTegra}/presumed-profit`, body, token);
};

export const putTaxesPresumed = async ({ token, body, id }: { token: string; body: any; id: number }) => {
  return put(`${urlApiTegra}/presumed-profit/${id}`, body, token);
};

export const putTaxesSimple = async ({ token, body, id }: { token: string; body: any; id: number }) => {
  return put(`${urlApiTegra}/cost-simple-national/${id}`, body, token);
};

export const deleteTaxesSimple = async ({ token, id }: { token: string; id: number }) => {
  return del(`${urlApiTegra}/cost-simple-national/${id}`, token);
};

export const deleteTaxesPresumed = async ({ token, id }: { token: string; id: number }) => {
  return del(`${urlApiTegra}/presumed-profit/${id}`, token);
};